module.exports = __webpack_public_path__ + "img/inter_oa.ac0ede6a.svg";